import React, {useEffect} from "react";
import styled from "styled-components";
import {White} from "../../../../Constants/ColorChart";
import {connect} from "react-redux";
import {hideSearchBar, setTitleBar} from "../../../../../actions/ui";
import "./DownloadManager.css";
import {
    HeaderTitle,
    StyledTable,
    TableHeader,
    Title,
    WrapperDiv
} from "../../../ResultTable/Components/ResultTableStyled/ResultTableStyled";
import {Tbody, Thead, Tr} from "react-super-responsive-table";
import DownloadManagerRow from "./DownloadManagerRow";
import {DownloadState} from "../../../../../Download/Reducer/Download";
import DocumentDownload from "../../../../../Download/Entity/DocumentDownload";
import DownloadManagerRowProgress from "./DownloadManagerRowProgress";

const StyledDiv = styled.div`
  color: ${White};
  width: calc(94% - 60px);
  margin-right: auto;
  margin-left: 80px;
  @media screen and (min-width: 992px) {
    margin-left: 280px;
    width: calc(94% - 250px);
  }
`;

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

type DownloadManagerSectionProps = {
    download: DocumentDownload[],
    hideSearchBar: () => void,
    setTitleBar: (title: string) => void
}

const DownloadManagerSection = (props: DownloadManagerSectionProps) => {
    const documents: DocumentDownload[] = props.download.length > 0 ? props.download : [];
    const firstDocument: DocumentDownload | null = documents[0] ?? null;
    const canShowProgressBar: boolean = firstDocument ? firstDocument.isDownloadingStatus() : false;

    useEffect(() => {
        props.hideSearchBar();
        props.setTitleBar("Download Manager");
    }, []);

    return (
        <StyledDiv>
            <WrapperDiv className={"download-manager"}>
                <WrapperTitle>
                    <Title>Download Manager</Title>
                </WrapperTitle>
                {documents.length > 0 &&
                  <StyledTable key="download-manager-table">
                    <Thead>
                      <Tr>
                        <TableHeader key={"type"}>
                          <HeaderTitle/>
                        </TableHeader>
                        <TableHeader key={"name"}>
                          <HeaderTitle>name</HeaderTitle>
                        </TableHeader>
                        <TableHeader key={"status"}>
                          <HeaderTitle>status</HeaderTitle>
                        </TableHeader>
                        <TableHeader key={"actions"}><HeaderTitle/></TableHeader>
                      </Tr>
                    </Thead>
                    <Tbody>
                        {documents.map((document: any, index: number) => {
                            return (
                                <React.Fragment key={"download-manager-table-row" + index}>
                                    <DownloadManagerRow document={document} index={index}/>
                                    {canShowProgressBar && 0 === index &&
                                      <DownloadManagerRowProgress document={document} index={index}/>}
                                </React.Fragment>
                            );
                        })}
                    </Tbody>
                  </StyledTable>}
                {documents.length === 0 && <p>No data to show</p>}
            </WrapperDiv>
        </StyledDiv>
    )
}

type DownloadManagerSectionStageProps = {
    download: DownloadState,
    hideSearchBar: () => void,
    setTitleBar: (title: string) => void
}

type mapStateToPropsType = {
    download: DocumentDownload[]
}

const mapStateToProps = (state: DownloadManagerSectionStageProps): mapStateToPropsType => (
    {
        download: state.download.download
    }
);

export default connect(mapStateToProps, {
    setTitleBar,
    hideSearchBar,
})(DownloadManagerSection);
